import { Component, OnInit } from '@angular/core';
import { PropertyService } from '../property';
import { AuthenticationService, UserService } from '@app/_services';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { RentalsUnitedService } from './rentals-united.service';

@Component({
    selector: 'app-rentals-united',
    templateUrl: './rentals-united.component.html',
    styleUrls: ['./rentals-united.component.css'],
    providers: [ConfirmationService, MessageService],
    standalone: false
})
export class RentalsUnitedComponent implements OnInit
{
  selectedShortTermRentalSummary: any;
  shortTermRentalSummaryList: any;
  selectedShortTermRental: any;
  tabIndex;
  formLoading;
  ruAccounts: any[];
  ruAccount: any = "prod";

  // OTA sync-all state
  syncAllLoading = false;
  syncAllResult: any = null;
  syncAllError: string = null;

  get currentUserRoles(): number[] {
    const user = this.authenticationService.currentUserValue;
    if (!user || !user.userRoles) { return []; }
    return user.userRoles.map((r: any) => r.userRoleId);
  }

  get canRunSyncAll(): boolean {
    const roles = this.currentUserRoles;
    return roles.includes(1050) || roles.includes(850);
  }

  constructor(private authenticationService: AuthenticationService,
    private userService: UserService,
    private propertyService: PropertyService,
    private rentalsUnitedService: RentalsUnitedService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private messageService: MessageService,
    private route: ActivatedRoute) {
      this.ruAccounts = rentalsUnitedService.ruAccounts;
     }

  ngOnInit(): void
  {
  }

  onPropertySelect(event)
  {
    // console.log('shortTermRentalSummary ' + JSON.stringify(event.value));
    this.findShortTermRentalById(event.value.shortTermRentalId);
  }

  onRUAccount(event)
  {
    // console.log('shortTermRentalSummary ' + JSON.stringify(event.value));
    this.ruAccount = event.value;
    this.ngOnChanges();
  }

  ngOnChanges() {

		this.ngOnInit();
	}

  findShortTermRentalById(shortTermRentalById: number)
  {
    this.formLoading = true;
    this.propertyService.findById(shortTermRentalById)
      .pipe(first())
      .subscribe(
        res =>
        {
          // console.log('findShortTermRentalById: ' + JSON.stringify(res));
          this.selectedShortTermRental = res.data.shortTermRental;

        },
        err =>
        {
          console.log('error In login.component is: ' + JSON.stringify(err));
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Login Failed', detail: 'We were unable to retrieve your properties: ' + err.message, life: 3000 });
        },
        () => { this.formLoading = false; });
  }

  confirmSyncAll() {
    this.confirmationService.confirm({
      message: 'This will sync all properties with all OTA channels. This may take 30–90 seconds. Continue?',
      header: 'Confirm OTA Sync All',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.runSyncAll();
      }
    });
  }

  runSyncAll() {
    this.syncAllLoading = true;
    this.syncAllResult = null;
    this.syncAllError = null;

    this.rentalsUnitedService.syncAllPropertiesStatus()
      .pipe(first())
      .subscribe(
        (res: any) => {
          this.syncAllResult = res.data;
          this.messageService.add({ severity: 'success', summary: 'Sync Complete', detail: res.message || 'OTA Sync All completed successfully.' });
        },
        (err: any) => {
          this.syncAllError = err?.error?.message || err?.message || 'An unexpected error occurred.';
          this.messageService.add({ severity: 'error', summary: 'Sync Failed', detail: this.syncAllError, life: 8000 });
        },
        () => { this.syncAllLoading = false; }
      );
  }

}
